import React from 'react';
import { useTranslation } from 'react-i18next';
import { isLeasedCategory } from '../../../../utils/helpers';
import { AgencyFilterResultsBlock } from '../AgencyFilterResultsBlock';
import { AgencyFilterResultsProps, Category } from './types';
import useScreenSize from '../../../../hooks/useScreenSize';
import { getCardsLimit } from '../getCardsLimit';

export const AgencyFilterResults: React.FC<AgencyFilterResultsProps> = ({
  agencyId,
  categories,
  activeCategoryId,
  activeLeasedCategory,
  onClickItem,
  setActiveLeasedCategory
}) => {
  const { t } = useTranslation();
  const { isSmall, isLarge } = useScreenSize();

  const getTitle = (category: Category) => {
    if (activeCategoryId === 'all' && isLeasedCategory(category.id)) {
      return t(`pages.agency.${category.id}`);
    }
    if (isLeasedCategory(activeCategoryId)) {
      return t(`pages.agency.filter.${activeCategoryId}`, {
        id: t(`pages.agency.filter.id_${category.id}`)
      });
    }
    if (isLeasedCategory(category.id)) {
      return t(`pages.agency.filter.${category.id}`, {
        id: t(`pages.agency.filter.id_${activeCategoryId}`)
      });
    }
    return category.title ?? '';
  };

  return (
    <div>
      {categories.map(category => {
        let shouldRender = false;
        let isLeased = false;
        let limit = getCardsLimit(isLarge, isSmall);
        let actualCategory = category;
        let activeId = activeCategoryId;

        if (activeCategoryId === 'all') {
          shouldRender = true;
        } else if (
          isLeasedCategory(activeCategoryId) &&
          !isLeasedCategory(category.id)
        ) {
          shouldRender = true;
          isLeased = true;
          limit =
            activeLeasedCategory.length > 1
              ? getCardsLimit(isLarge, isSmall)
              : 20;
        } else if (
          activeLeasedCategory.includes(category.id) &&
          !isLeasedCategory(activeCategoryId) &&
          isLeasedCategory(category.id)
        ) {
          shouldRender = true;
          isLeased = true;
          limit =
            activeLeasedCategory.length > 1
              ? getCardsLimit(isLarge, isSmall)
              : 20;
          actualCategory = { id: activeCategoryId };
          activeId = category.id;
        }

        if (!shouldRender) return null;

        return (
          <AgencyFilterResultsBlock
            key={category.id}
            title={getTitle(category)}
            category={actualCategory}
            agencyId={agencyId}
            activeCategoryId={activeId}
            limit={limit}
            isLeased={isLeased}
            onClickItem={onClickItem}
            setActiveLeasedCategory={
              isLeased ? setActiveLeasedCategory : undefined
            }
          />
        );
      })}
    </div>
  );
};
